exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teacherDigestContainer .digestContent .dataLogTables .logRow td.dateCell{text-align:left;width:20%}.teacherDigestContainer .digestContent .dataLogTables .silverTextContainer{font-size:.8em}.teacherDigestContainer .digestContent .dataLogTables .silverTextContainer .btn-link{padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/data_log_tables.scss
// module id = 1289
// module chunks = 0